import React from 'react';
import styles from './DocTable.module.css';

interface DocTableColumn {
  header: string;
  accessor: string;
  mono?: boolean;
  nowrap?: boolean;
}

interface DocTableProps {
  columns: DocTableColumn[];
  data: Record<string, React.ReactNode>[];
}

export const DocTable: React.FC<DocTableProps> = ({ columns, data }) => {
  return (
    <div className={styles.wrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.accessor}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {columns.map((col) => (
                <td
                  key={col.accessor}
                  className={`${col.mono ? styles.mono : ''} ${col.nowrap ? styles.nowrap : ''}`}
                >
                  {row[col.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
